import styled from 'styled-components';

import StyledNotes from '../Notes/StyledNotes';

export default styled(StyledNotes)`
  .content {
    height: 108px;
  }
  .buttonRow {
    padding: 4px;
  }
`;
